module.exports = __webpack_public_path__ + "img/qrcode_android.4abf158c.png";